var map = {
	"./de.json": [
		33116,
		116
	],
	"./en.json": [
		8921,
		921
	],
	"./fr.json": [
		83056,
		56
	],
	"./ja.json": [
		23160,
		160
	],
	"./ko.json": [
		55540,
		540
	],
	"./th.json": [
		19481,
		481
	],
	"./vi.json": [
		65143,
		143
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 37472;
module.exports = webpackAsyncContext;